
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"margin":"auto","background":"0 0","animation-play-state":"running","animation-delay":"0s"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"margin:auto;background:0 0;animation-play-state:running;animation-delay:0s","width":"184","height":"184","viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid","display":"block"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticStyle:{"animation-play-state":"running","animation-delay":"0s"},attrs:{"cx":"50","cy":"50","fill":"none","stroke":"#ec2f3b","stroke-width":"3","r":"18","stroke-dasharray":"84.82300164692441 30.274333882308138","transform":"rotate(226.858 50 50)"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"0.6578947368421053s","values":"0 50 50;360 50 50","keyTimes":"0;1"}})])])
          )
        }
      }
    